import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "@emotion/styled"

const FormContainer = styled.div`
    width: 650px;
    margin: 0.5em auto 0;
    padding: 1em 3em 0 3em;
    background: #fff;
    @media screen and (max-width: 800px) {
        padding: 1em;
        margin: 0.5em 1em;
    }
    @media screen and (max-width: 575px) {
        & > div {
            flex-direction: column;
        }
    }
`

const ContactForm = () => {
    const data = useStaticQuery(query)
    const content = data.strapiPage.content.find((x) => x.external_script)
    const formScript = content.external_script.filter(
        (x) => x.name === "contact_form"
    )
    return (
        <FormContainer>
            <div
                dangerouslySetInnerHTML={{ __html: formScript[0].script }}
            ></div>
        </FormContainer>
    )
}
export default ContactForm

const query = graphql`
    query {
        strapiPage(slug: { eq: "contact-us" }) {
            content {
                external_script {
                    id
                    name
                    script
                }
            }
        }
    }
`
